import AccommodateScrollBarBox from "designSystem/components/box/AccommodateScrollBarBox";
import { grey, red } from "designSystem/styles/color";
import { Box, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={4}>
			<Text semiBold text="Normal vertical" />
			<Text semiBold text="Overflow vertical" />
			<Text semiBold text="Normal horizontal" />
			<Text semiBold text="Overflow horizontal" />
			<AccommodateScrollBarBox
				layout="vertical"
				maxHeight={100}
				style={{ resize: "vertical", backgroundColor: red[800] }}
			>
				<Box style={{ backgroundColor: grey[800] }}>
					<Text text="Resize the container, make the height fit/doesn't fit the container height" />
					<Text text="Resize the container, make the height fit/doesn't fit the container height" />
				</Box>
			</AccommodateScrollBarBox>
			<AccommodateScrollBarBox
				layout="vertical"
				maxHeight={50}
				style={{ resize: "vertical", backgroundColor: red[800] }}
			>
				<Box style={{ backgroundColor: grey[800] }}>
					<Text text="Resize the container, make the height fit/doesn't fit the container height" />
					<Text text="Resize the container, make the height fit/doesn't fit the container height" />
					<Text text="Resize the container, make the height fit/doesn't fit the container height" />
				</Box>
			</AccommodateScrollBarBox>
			<AccommodateScrollBarBox
				layout="horizontal"
				maxWidth={100}
				style={{ resize: "horizontal", backgroundColor: red[800] }}
			>
				<Box style={{ backgroundColor: grey[800] }}>
					<Text text="Resize the container, make the width fit/doesn't fit the width" />
				</Box>
			</AccommodateScrollBarBox>
			<AccommodateScrollBarBox
				layout="horizontal"
				style={{ resize: "horizontal", backgroundColor: red[800] }}
				width={46}
			>
				<Box style={{ backgroundColor: grey[800] }}>
					<Text text="Resize the container" />
				</Box>
			</AccommodateScrollBarBox>
		</CssColumnGrid>
	);
};